import React, { useState, useEffect, useCallback } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import TableData from "./component/tableData";
import AddUpdateContentPopup from "./component/addUpdateContentPop";
import { useSelector } from "react-redux";
import add_new from "../../../Assets/svg/add_new.svg";
import { get, updateToken } from "../../../helpers/api_helper";
import Pagination from "../../../components/Pagination";
import useCheckPermission from "../../../hooks/useCheckPermission";

const Faq = () => {
  const token = useSelector((state) => state.login.token);
  const [faqData, setFaqData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchFaq = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const response = await get(
          `/faq/list?skip=${page}&limit=${itemsPerPage}`
        );
        if (response.success) {
          setFaqData(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 0);
        } else {
          console.log(response.message || "Failed to fetch FAQ");
          setFaqData([]);
        }
      } catch (error) {
        console.log(error);
        setFaqData([]);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchFaq(currentPage);
    }
  }, [token, fetchFaq, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleAddFaq = () => {
    setModalMode("create");
    setSelectedFaq(null);
    setShowModal(true);
  };

  return (
    <>
      <AddUpdateContentPopup
        showModal={showModal}
        setShowModal={setShowModal}
        handleRefresh={() => fetchFaq(currentPage)}
        mode={modalMode}
        faqData={selectedFaq}
        resetFormOnClose={showModal}
      />
      <section className="contentPage position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-start sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h5 className="m-0 fw-sbold">FAQ Management</h5>
                  <p className="m-0 text-muted py-1">
                    It is a long established fact that a reader will be
                    distracted by the readable
                  </p>
                </div>
                <div className="right">
                  {useCheckPermission("faq", "CREATE") && <Button
                    onClick={handleAddFaq}
                    className="d-flex align-items-center justify-content-center rounded-pill"
                  >
                    Add New FAQ{" "}
                    <span className="icn ms-2">
                      <img src={add_new} alt="" />
                    </span>
                  </Button>}
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="commonTable scrollable-table-container">
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100px" }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : faqData.length > 0 ? (
                  <>
                    <TableData
                      faqData={faqData}
                      setRefresh={() => fetchFaq(currentPage)}
                    />
                    {faqData.length > 10 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    )}
                  </>
                ) : (
                  <p>No FAQ data available.</p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Faq;
